// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1brUk","list":"BalanceDue_list__254DB","listRow":"BalanceDue_listRow__2gs2I","total":"BalanceDue_total__N2qUe"};